import { mergeToNewObject } from '../../../util/helpers'
import { WALLET_RESTORE } from '../../../constants/actions'

export const restoreProfile = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case WALLET_RESTORE.ON_PASSWORD_CHANGE:
      return mergeToNewObject(state, { password: payload })

    case WALLET_RESTORE.ON_REPEAT_PASSWORD_CHANGE:
      return mergeToNewObject(state, { repeatPassword: payload })

    case WALLET_RESTORE.ON_MNEMONIC_CHANGE:
      return mergeToNewObject(state, { mnemonic: payload })

    case WALLET_RESTORE.ON_WALLET_RESTORED:
      return mergeToNewObject(state, { restored: true })

    case WALLET_RESTORE.ON_RESET_STATE:
      return INITIAL_STATE

    default:
      return state
  }
}

const INITIAL_STATE = {
  mnemonic: '',
  password: '',
  repeatPassword: '',
  restored: false
}



// WEBPACK FOOTER //
// ./src/store/reducers/wallet/restore.js